module.exports = __webpack_public_path__ + "static/media/by.ad33ee06.svg";


//////////////////
// WEBPACK FOOTER
// ./~/react-flags-select/flags/by.svg
// module id = 612
// module chunks = 0